import script from "./CarteleraSubastas.vue?vue&type=script&setup=true&lang=js"
export * from "./CarteleraSubastas.vue?vue&type=script&setup=true&lang=js"

import "./CarteleraSubastas.vue?vue&type=style&index=0&id=7fafca80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fafca80"]])

export default __exports__